'use client';

import {PageLoader} from 'app/components/core/Page/PageLoader';
import {useAuthentication} from 'app/hooks/useAuthentication';

import Title from './components/Title';
import Wrapper from './components/Wrapper';
import {useGetElegibility} from 'app/hooks/useElegibility';
import Elegible from './Elegible/Elegible';
import {LoginForm} from 'app/shared/LoginForm/LoginForm';
export const Elegibility = () => {
  const {state, connected, address} = useAuthentication();
  const {
    data: airdropData,
    isLoading: isLoadingAirdrop,
    status: airdropStatus,
    total: airdropTotal,
    elysTotal: airdropElysTotal,
    refetch,
  } = useGetElegibility(address);

  if (state !== 'initialized' || (connected && isLoadingAirdrop)) {
    return <PageLoader />;
  }

  if (connected && !isLoadingAirdrop) {
    return (
      <Elegible
        refetch={refetch}
        airdropStatus={airdropStatus}
        airdropData={airdropData}
        address={address}
        total={airdropTotal}
        elysTotal={airdropElysTotal}
      />
    );
  }

  return (
    <Wrapper backgroundUrl="/background/elegibility-checker-background.webp">
      <Title
        title="Reward Program <br /> Eligibility Checker"
        className="mb-4"
      />
      <p className="mb-4 max-w-[462px] text-center text-xl mobile:text-base">
        Login in with your wallet address below to check your eligibility for
        the Reward Program.
      </p>
      <div className="z-10">
        <LoginForm compact />
      </div>
    </Wrapper>
  );
};
